import { render, staticRenderFns } from "./unitInformationCollection.vue?vue&type=template&id=17d34821&"
import script from "./unitInformationCollection.vue?vue&type=script&lang=js&"
export * from "./unitInformationCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports